// extracted by mini-css-extract-plugin
export default {"wrapper":"wlhsh","root":"dnkiD","cashier":"B0WR8","container":"buhOW","title":"ctCLd","subTitle":"DdkOJ","icon":"DSfC5","button":"jw7Bc"};